<template>
  <v-container :loading="loading">
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-table-search"
          label="Suche"
          single-line
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-data-table
        :headers="pruchaseItemsTableHeaders"
        :search="search"
        :items="pruchaseItems"
        :item-class="positionBackground"
        dense
        item-key="id"
        :items-per-page="-1"
      >
        <template #[`item.price`]="{item}">
          {{ item.price }} €
        </template>
        <template #[`item.ampel`]="{item}">
          <div>
            <v-icon v-if="item.ampel == 'rot'" :color="'error'" class="center" x-medium>
              mdi-cart-variant
            </v-icon>
            <v-icon v-if="item.ampel == 'gelb'" :color="'orange'" class="center" x-medium>
              mdi-cart-variant
            </v-icon>
            <v-icon v-if="item.ampel == 'gruen'" :color="'success'" class="center" x-medium>
              mdi-cart-variant
            </v-icon>
          </div>
        </template>
        <template #[`item.full_price`]="{item}">
          {{ item.full_price }} €
        </template>
      </v-data-table>
    </v-row>
    <v-row>
      <v-col cols="12" class="my-0">
        <v-divider />
      </v-col>
      <v-col cols="12" class="d-flex justify-end">
        <v-list>
          <li>Wareneinsatz gesamt: {{ fullPrice }} €</li>
          <li>Auftragsvolumen gesamt: {{ turnover.sum }} €</li>
          <li>Reingewinn gesamt: {{ turnover.profit }} €</li>
          <li>Reingewinn monatlich: {{ turnover.profit_mon }} €</li>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   components: {
   },
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : `Vertrag ${this.contract.number}`,
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      contract: {
         type: Object,
         required: true,
      },
      pruchaseItems: {
         type: Array,
         required: true,
      },
      fullPrice: {
         type: Number,
         required: true
      },
      turnover: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         loading: false,
         tab: 4,
         search: '',
         pruchaseItemsTableHeaders: [
            { text: 'Einnkaufsartikel', value: 'name' },
            { text: 'Lieferrant', value: 'supplier' },
            { text: 'Positionen', value: 'position' },
            { text: 'Status', value: 'ampel' },
            { text: 'Benötigt', value: 'amount' },
            { text: 'Kommissioniert', value: 'comission' },
            { text: 'Fehlen', value: 'missing' },
            { text: 'Bestellt', value: 'ordered' },
            { text: 'Im Lager', value: 'stock' },
            { text: 'Im Zulauf', value: 'zulauf' },

            { text: 'Einkauf Preis stk.', value: 'price' },
            { text: 'Gesammtpreis', value: 'full_price' },
         ],
      }
   },
   computed: {

   },
   methods: {
   },
}
</script>
